import { render, staticRenderFns } from "./life-card-bussiness-coupons.vue?vue&type=template&id=a8433158&scoped=true&lang=pug&"
import script from "./life-card-bussiness-coupons.vue?vue&type=script&lang=js&"
export * from "./life-card-bussiness-coupons.vue?vue&type=script&lang=js&"
import style0 from "./life-card-bussiness-coupons.vue?vue&type=style&index=0&id=a8433158&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8433158",
  null
  
)

export default component.exports